module.exports = __webpack_public_path__ + "img/cheque3.9370bc79.jpg";